import styled from "styled-components";

// Main container and layout components
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const FormLabel = styled.div`
  width: 30%;

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom:8px;
  }

  @media (max-width: 1279px) and (min-width: 768px) {
    width: 50%;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;

  @media (max-width: 767px) {
    width: 100%;
  }
  @media (max-width: 1279px) and (min-width: 768px) {
    width: 50%;
  }
`;

// Divider components
export const ProductDivider = styled.div`
  position: relative;
  width: 100vw;
  height: 17px;
  background-color: #fffdf2;
  border: 1px solid #fae8d2;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  @media screen and (max-width: 767px) {
    position: relative;
    width: 100vw;
    height: 17px;
    background-color: #fffdf2;
    border: 1px solid #fae8d2;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
`;

export const OptionDivider = styled.div`
  width: calc(100% + 88px);
  height: 2px;
  background-color: #e39435;
  margin-left: -44px;

  @media screen and (max-width: 767px) {
    width: 100vw !important;
    height: 2px;
    background-color: #e39435;
    margin-left: -30px !important;
  }
`;

export const ChoiceDivider = styled.div`
  width: calc(100% + 88px);
  height: 2px;
  background-color: #e2e2e2;
  margin-left: -44px;

  @media screen and (max-width: 767px) {
    width: 100vw !important;
    height: 2px;
    background-color: #e2e2e2;
    margin-left: -30px !important;
  }
`;

// Button components
export const SendButton = styled.button`
  background-color: #a5a5a5 !important;
  color: #fff;
  width: 150px;
  margin-right: 8px !important;
  font-size: 16px;
  font-weight: 700;
  height: 56px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &.h-50 {
    height: 50px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const SendButtonActive = styled.button`
  background-color: #e39435 !important;
  color: #fff !important;
  width: 180px;
  font-size: 16px;
  font-weight: 700;
  height: 56px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &.h-50 {
    height: 50px;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const AddSubOptionsButton = styled.button`
  background-color: #e39435 !important;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  border-radius: 4px;
  text-transform: capitalize;
  border: none;
  cursor: pointer;
  box-shadow: none;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  width: 101px;

  &.mb-16 {
    margin-bottom: 16px;
  }
`;

export const PriceDisplayBox = styled.div`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #a5a5a5;
  padding: 8px;
  color: #a5a5a5;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddOptionsButton = styled.button`
  background-color: #5ba43b !important;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  border-radius: 4px;
  width: 148px;
  text-transform: capitalize;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: none;
  float: right;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const AvailabilityToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #76b041;
  }

  &:checked + span:before {
    transform: translateX(26px);
  }
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 14px;
  margin-top: 4px;
  font-weight: 500;
`;

export const SuccessMessage = styled.div`
  color: #28a745;
  font-size: 14px;
  margin-top: 4px;
  font-weight: 500;
`;

// Review Modal Components
export const ReviewModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
`;

export const ReviewModalContent = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    max-width: 95vw;
    margin: 10px;
  }
`;

export const ReviewModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  background: white;
  border-radius: 16px 16px 0 0;
`;

export const ReviewModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1e2f23;
  margin: 0;
`;

export const ReviewModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }

  svg {
    width: 20px;
    height: 20px;
    color: #666;
  }
`;

export const ReviewModalBody = styled.div`
  padding: 20px 24px;
  max-height: 60vh;
  overflow-y: auto;
`;

export const ReviewImageContainer = styled.div`
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  position: relative;

  @media (max-width: 480px) {
    height: 150px;
  }
`;

export const ReviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ReviewImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  background-color: #f5f5f5;
`;

export const ReviewItemDetails = styled.div`
  margin-bottom: 24px;
`;

export const ReviewItemName = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #1e2f23;
  margin: 0 0 8px 0;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const ReviewItemPrice = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #e39435;
  margin-bottom: 12px;

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const ReviewItemDescription = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 12px 0;
`;

export const ReviewCategoryTag = styled.span`
  display: inline-block;
  background-color: #e39435;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
`;

export const ReviewOptionsSection = styled.div`
  margin-top: 16px;
`;

export const ReviewOptionsTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #1e2f23;
  margin: 0 0 12px 0;
`;

export const ReviewOptionGroup = styled.div`
  margin-bottom: 8px;
  font-size: 14px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ReviewOptionGroupName = styled.span`
  font-weight: 600;
  color: #1e2f23;
`;

export const ReviewOptionGroupOptions = styled.span`
  color: #666;
`;

export const ReviewModalActions = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e0e0e0;
  position: sticky;
  bottom: 0;
  background: white;
  border-radius: 0 0 16px 16px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const ReviewModalButton = styled.button<{
  $variant?: "primary" | "secondary";
}>`
  flex: 1;
  height: 48px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) =>
    props.$variant === "primary"
      ? `
    background: linear-gradient(135deg, #e39435 0%, #f4a261 100%);
    color: white;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(227, 148, 53, 0.3);
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  `
      : `
    background: #f8f9fa;
    color: #666;
    border: 1px solid #e0e0e0;
    
    &:hover {
      background: #e9ecef;
    }
  `}

  @media (max-width: 480px) {
    min-height: 38px !important;
    font-size: 14px !important;
  }
`;

export const ReviewLoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ReviewOptionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #1e2f23;
  margin: 0 0 12px 0;
`;

// Food Option Header Components
export const OptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const OptionTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color, #1E2F23);
  margin-right: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
`;

export const DeleteOptionButton = styled.div`
  color: var(--primary-color, #1E2F23);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const DeleteOptionText = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: var(--primary-color, #1E2F23);
`;

// Helper Text Components
export const HelpIconContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const FormLabelWithHelper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const HelperTextPopup = styled.div<{ $visible: boolean }>`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 300px;
  max-width: 400px;
  font-size: 14px;
  color: #4a5568;
  line-height: 1.4;
  margin-top: 8px;
  display: ${props => props.$visible ? 'block' : 'none'};

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid white;
  }

  &::after {
    content: '';
    position: absolute;
    top: -7px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #e2e8f0;
  }

  @media (max-width: 767px) {
    min-width: 250px;
    max-width: 300px;
    font-size: 13px;
    padding: 10px 14px;
  }
`;

export const HelperTextContent = styled.div`
  font-weight: 500;
  
  .highlight {
    color: #e39435;
    font-weight: 600;
  }
`;

// Time Input Component
export const TimeInputField = styled.input`
  max-width: 680px;
  width:100%;
  height: 56px;
  padding: 16px;
  border: 1px solid #e39435;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e2f23;
  background-color: white;
  outline: none;

  &:focus {
    border-color: #d18429;
    box-shadow: 0 0 0 3px rgba(227, 148, 53, 0.1);
  }

  &::placeholder {
    color: #b0b0b0;
    font-weight: 400;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
